export default "__VITE_ASSET__BnuZo7fS__"